<script lang="ts">
  import ContentBlockHighlights from "@shared/svelte/Components/ContentBlock/ContentBlockHighlights.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";

  import type { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

  export let title: string;
  export let description: string;
  export let href: string;
  export let target: string;
  export let hoveringOnImage: boolean;
  export let handleClick: (entities: BaseEntityClass[]) => void;
  export let highlights: string[] = [];
  export let mobileMode: boolean;

  let hoveringOnTitle: boolean = false;
  const enter = () => {
    hoveringOnTitle = true;
  };
  const leave = () => {
    hoveringOnTitle = false;
  };

  $: inHoverState = hoveringOnImage || hoveringOnTitle;

  const titleMissing = (title || "X").split("").every(c => c === "X" || c === " ");
  const descriptionMissing = (description || "X").split("").every(c => c === "X" || c === " ");

</script>

<style>
  .content-block-title {
    color: #1b1b1b;
  }
  .content-block-title-hover {
    color: #008fbe;
  }

  a:hover {
    text-decoration: none;
  }

</style>

<TrackingContext let:trackingContext>
  <div class="fizz-flex-row fizz-full-width">
    <div class="fizz-flex-vertical">
      <div class="fizz-stack-8">
        <a
          {href}
          {target}
          on:click={() => handleClick(trackingContext.entities)}
          on:mouseover={enter}
          on:focus={enter}
          on:mouseleave={leave}
        >
          <span
            class="fizz-heading-3"
            class:content-block-title-hover={inHoverState}
            class:content-block-title={!inHoverState}
            class:content-block-title-missing={titleMissing}
            data-testid={`content-block-title${titleMissing ? "-missing" : ""}`}
          >
            {title}
          </span>
        </a>
      </div>
      <div class="fizz-stack-4">
        <span
          class="content-block-description"
          class:content-block-description-missing={descriptionMissing}
          data-testid={`content-block-description${descriptionMissing ? "-missing" : ""}`}
        >
          {description}
        </span>
      </div>
      {#if !mobileMode}
        <ContentBlockHighlights {highlights} dataTestIdSuffix={"in-body"} />
      {/if}
    </div>
  </div>
</TrackingContext>
